import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchBar from '../SearchBar';
import './Navbar.css';

const Navbar = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const navigate = useNavigate();

  const handleRegionClick = (region) => {
    navigate('/region', { state: { region: region } });
  };

  return (
    <>
      <nav className="site-navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-brand">
            <span className="brand-accent">Half Time</span> Whistle
          </Link>
          
          <ul className="navbar-menu">
            <li><Link to="/">Home</Link></li>
            
            <li className="nav-dropdown">
              <Link to="/northamerica">North America ▾</Link>
              <ul className="dropdown-menu">
                <li onClick={() => handleRegionClick('NorthEast')}>North East</li>
                <li onClick={() => handleRegionClick('MidWest')}>Mid West</li>
                <li onClick={() => handleRegionClick('West')}>West</li>
                <li onClick={() => handleRegionClick('SouthCentral')}>South Central</li>
                <li onClick={() => handleRegionClick('SouthEast')}>South East</li>
                <li onClick={() => handleRegionClick('Jamaica')}>Jamaica</li>
                <li onClick={() => handleRegionClick('Canada')}>Canada</li>
              </ul>
            </li>

            <li className="nav-dropdown">
              <Link to="/centralamerica">Central America ▾</Link>
              <ul className="dropdown-menu">
                <li onClick={() => handleRegionClick('costarica')}>Costa Rica</li>
              </ul>
            </li>

            <li className="nav-dropdown">
              <Link to="/europe">Europe ▾</Link>
              <ul className="dropdown-menu">
                <li onClick={() => handleRegionClick('Italy')}>Italy</li>
                <li onClick={() => handleRegionClick('France')}>France</li>
                <li onClick={() => handleRegionClick('Monaco')}>Monaco</li>
                <li onClick={() => handleRegionClick('England')}>England</li>
                <li onClick={() => handleRegionClick('Iceland')}>Iceland</li>
                <li onClick={() => handleRegionClick('Norway')}>Norway</li>
                <li onClick={() => handleRegionClick('Sweden')}>Sweden</li>
                <li onClick={() => handleRegionClick('Greece')}>Greece</li>
              </ul>
            </li>

            <li className="nav-dropdown">
              <Link to="/asia">Asia ▾</Link>
              <ul className="dropdown-menu">
                <li onClick={() => handleRegionClick('India')}>India</li>
                <li onClick={() => handleRegionClick('Japan')}>Japan</li>
              </ul>
            </li>

            <li className="nav-dropdown">
              <Link to="/oceania">Oceania ▾</Link>
              <ul className="dropdown-menu">
                <li onClick={() => handleRegionClick('Australia')}>Australia</li>
              </ul>
            </li>
          </ul>

          <div className="navbar-actions">
            <button className="search-trigger-btn" onClick={() => setIsSearchOpen(true)}>
              <span className="search-icon">🔍</span> Search
            </button>
          </div>
        </div>
      </nav>

      <SearchBar isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
};

export default Navbar;
